import GenericButton from "../../../../shared/ui/GenericButton";
import PageTitle from "../../../../shared/ui/PageTitle";
import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import {useNavigate} from "react-router-dom";
import Grid from "@mui/material/Grid";
import FormLabelBox from "../../../../shared/ui/FormLabelBox";
import FormFieldBox from "../../../../shared/ui/FormFieldBox";
import ErrorsList from "../../../../shared/ui/ErrorsList";
import BoxContent from "../../../../shared/ui/BoxContent";
import {useAuth} from "../../../../hooks/useAuth";
import * as yup from "yup";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {ApiGetAllTags} from "../../../tests/tags/api/testTags";
import FormField from "../../../../shared/form/FormField";
import CustomDatePicker from "../../../../shared/form/CustomDatePicker";
import CustomButton from "../../../../shared/ui/CustomButton";
import {APIGetAllClassrooms} from "../../../classrooms/api/classrooms";
import {getRomanNumber} from "../../../../utils/functions";
import moment from "moment";
import {APITestGenerateLogs} from "../../activityReport/api/logs";
import * as XLSX from "xlsx";
import {getSubjects} from "../../../../utils/subjects";
import {SelectChangeEvent} from "@mui/material/Select";

export interface IFormInputs {
    interval: string;
    tag: any[];
    classroom: { label: string; value: string; id: string; name: string; grade: number } | undefined;
    subject: string;
    testType: string;
}

const schema = yup.object({
});

const GenerateClassroomLogs = () => {
    const navigate = useNavigate();
    const { update, tenant } = useAuth();
    const [classrooms, setClassrooms] = useState<any[]>([]);
    const [tags, setTags] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<Date>();
    const [endDate, setEndDate] = useState<Date>();
    const [errorMessage, setErrorMessage] = useState("");
    const [subjects, setSubjects] = useState<any[]>([]);
    const [subject, setSubject] = useState<string>("");
    const [testType, setTestType] = useState<string>("school");

    const methods = useForm<IFormInputs>({
        resolver: yupResolver(schema),
    });

    const selectOptions = [
        {
            label: "Teste școlare",
            value: "school",
        },
        {
            label: "Teste pregătire BAC",
            value: "bac",
        },
        {
            label: "Teste pregătire Evaluare Națională",
            value: "evaluate",
        },
        {
            label: "Teste de antrenament",
            value: "training",
        },
        {
            label: "Teste de literație",
            value: "literacy",
        },
        {
            label: "Teste de literație digitală",
            value: "digital-literacy",
        },
        {
            label: "Teste de literație numerică",
            value: "numerical-literacy",
        },
        {
            label: "Teste proprii",
            value: "personal",
        },
    ];

    useEffect(() => {
        if(testType === "digital-literacy" || testType === "numerical-literacy" || testType === "literacy") {
            setSubjects([]);
        } else if(testType === "personal") {
            setSubjects(getSubjects("customTest"));
        } else {
            setSubjects(getSubjects(testType));
        }
    }, [testType]);

    useEffect(() => {
        ApiGetAllTags()
            .then((response) => {
                if (response.data.success) {
                    setTags(response.data.data.values);
                    // setLoading(false);
                } else {
                    update("error", { show: true, code: "A002" });
                }
            })
            .catch((err) => {
                update("error", { show: true, code: "A001" });
            });

        APIGetAllClassrooms()
            .then((response) => {
                if (response.data.success) {
                    // console.log("getClassroom OK", response);
                    const classrooms = response.data.data.items.map((item: { name: string; grade: number; id: string }) => {
                        return {
                            label: `(${getRomanNumber(item.grade)}) ${item.name}`,
                            value: item.id,
                            ...item,
                        };
                    });
                    setClassrooms(classrooms);
                } else {
                    update("error", { show: true, code: "A002" });
                }
            })
            .catch((err) => {
                // console.log("getClassroom ERR", err);
                update("error", { show: true, code: "A001" });
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onDateRangeChange = (dates: any) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        methods.clearErrors("interval");
    };

    const handleSelectChange = (e: React.FormEvent<HTMLInputElement>) => {
        const target = e.target as HTMLInputElement;
        setTestType(target.value);
        setSubject("");
    }

    const setSubjectHandler = (event: SelectChangeEvent) => {
        const target = event.target as HTMLInputElement;
        setSubject(target.value);
    }

    const handleClearSubject = () => {
        setSubject("");
    }

    const onSubmit: SubmitHandler<IFormInputs> = (data) => {
        methods.clearErrors();
        setErrorMessage("");
        const selectedTags = data.tag.map((item : {value: string} ) => item.value);
        const selectedClassroom = data.classroom ? data.classroom.id : null;
        if(
            testType !== "" ||
            subject !== "" ||
            selectedTags.length !== 0 ||
            selectedClassroom ||
            startDate !== undefined ||
            endDate !== undefined
        ) {
            update("loading", { show: true, modal: true });
            APITestGenerateLogs({
                type: testType,
                item_type_id: subject,
                tag: selectedTags,
                classroom: selectedClassroom,
                start_date: startDate ? moment(startDate).locale("ro").format("YYYY-MM-DD HH:mm:ss") : "",
                end_date: endDate ? moment(endDate).locale("ro").format("YYYY-MM-DD HH:mm:ss") : "",
            })
                .then((response) => {
                    if (response.data.success) {
                        // console.log("response", response.data);
                        if(response.data.data.values.length === 0) {
                            update("error", {
                                show: true,
                                closable: true,
                                title: "Nu exista date pentru export",
                                message: "",
                                icon: "fat face-eyes-xmarks",
                                button: "ÎNCHIDE",
                            });
                        } else {
                            const data = (response.data.data.values.map((log: any) => {
                                return {
                                    "ID sesiune": log.test_id,
                                    Elev: log.student_id,
                                    "Iesiri": log.total_exits_count,
                                    "Timp total iesiri (secunde)": log.total_exit_time_seconds,
                                };
                            }))
                            const ws = XLSX.utils.json_to_sheet(data);
                            const wb = XLSX.utils.book_new();
                            XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
                            /* generate XLSX file and send to the client */
                            XLSX.writeFile(wb, `Loguri-${tenant.name}${startDate ? `-${moment(startDate).locale("ro").format("DD.MM.YYYY")}` : ""}${endDate ? `-${moment(endDate).locale("ro").format("DD.MM.YYYY")}` : ""}.xlsx`);
                        }
                        setStartDate(undefined);
                        setEndDate(undefined);
                        setErrorMessage("");
                        methods.reset({
                            classroom: undefined,
                            tag: [],
                            interval: "",
                        });
                        update("loading", { show: false, modal: true });
                    } else {
                        update("error", { show: true, code: "A002" });
                        update("loading", { show: false, modal: true });
                    }
                })
                .catch((err) => {
                    if (err.response.status === 400) {
                        let errors = err.response.data.data;
                        if (errors.end_date) {
                            methods.setError("interval", { type: "server", message: errors.end_date[0] });
                        }
                        if (errors.tag) {
                            methods.setError("tag", { type: "server", message: errors.tag[0] });
                        }
                        if (errors.classroom) {
                            methods.setError("classroom", { type: "server", message: errors.classroom[0] });
                        }
                        if (errors.item_type_id) {
                            methods.setError("subject", { type: "server", message: errors.item_type_id[0] });
                        }
                        if(errors.error) {
                            setErrorMessage(errors.error);
                        }
                        update("loading", { show: false });
                    } else {
                        update("error", { show: true, code: "A001" });
                        update("loading", { show: false, modal: true });
                    }
                });
        } else {
            setErrorMessage("Nu ați modificat niciun câmp.");
        }
    }

    return (
        <Box component="main">
            <PageTitle
                back={true}
                actions={
                    <GenericButton
                        type="close"
                        onClick={() => {
                            navigate(-1);
                        }}
                    />
                }>
                Generează log
            </PageTitle>
            <BoxContent>
                <Box width="100%">
                    <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
                            <Grid container spacing={1.5} alignItems="center">
                                <FormLabelBox title="Tip test:" />
                                <FormFieldBox>
                                    <FormField
                                        name="testType"
                                        type="controlled-select"
                                        label="Alege tipul testelor"
                                        defaultValue={testType}
                                        value={testType}
                                        onChange={handleSelectChange}
                                        options={selectOptions}
                                        errorMessage={methods.formState.errors.testType?.message}
                                        error={!!methods.formState.errors.testType?.message}
                                    />
                                </FormFieldBox>

                                <FormLabelBox title="Materie:" />
                                <FormFieldBox>
                                    <FormField
                                        disabled={testType === "literacy" || testType === "digital-literacy" || testType === "numerical-literacy"}
                                        name="subject"
                                        type="controlled-select"
                                        label="Alege materia"
                                        defaultValue={subject}
                                        value={subject}
                                        onChange={setSubjectHandler}
                                        onClick={() => {
                                            handleClearSubject();
                                            methods.reset();
                                        }}
                                        options={subjects.map((item: { name: string; id: string }) => {
                                            return {
                                                label: item.name,
                                                value: item.id,
                                                ...item,
                                            };
                                        })}
                                        errorMessage={methods.formState.errors.subject?.message}
                                        error={!!methods.formState.errors.subject?.message}
                                    />
                                </FormFieldBox>

                                <FormLabelBox title="Clasă:" />
                                <FormFieldBox>
                                    <FormField
                                        name="classroom"
                                        type="autocomplete"
                                        label="Alege clasa"
                                        multiple={false}
                                        options={classrooms}
                                        defaultValue={null}
                                        errorMessage={methods.formState.errors.classroom?.message}
                                        error={!!methods.formState.errors.classroom?.message}
                                        disableClearable={true}
                                    />
                                </FormFieldBox>

                                <FormLabelBox title="Tag:" />
                                <FormFieldBox>
                                    <FormField
                                        name="tag"
                                        type="autocomplete"
                                        label="Alege tagul"
                                        multiple={true}
                                        defaultValue={[]}
                                        options={tags.map((item: string) => {
                                            return {
                                                label: item,
                                                value: item,
                                            };
                                        })}
                                        errorMessage={methods.formState.errors.tag?.message}
                                        disableClearable={true}
                                        error={!!methods.formState.errors.tag?.message}
                                        limitTags={4}
                                    />
                                </FormFieldBox>

                                <FormLabelBox title="Perioadă:" />
                                <FormFieldBox>
                                    <CustomDatePicker
                                        name="interval"
                                        startDate={startDate}
                                        endDate={endDate}
                                        onDateChange={onDateRangeChange}
                                        type="dateRangePicker"
                                        small={false}
                                        errorMessage={methods.formState.errors.interval?.message}
                                        error={!!methods.formState.errors.interval?.message}
                                    />
                                </FormFieldBox>

                                <FormLabelBox />
                                <FormFieldBox>
                                    <CustomButton
                                        bgcolor="dark"
                                        submit
                                        buttonType="textIcon"
                                    >
                                        Generează Raport
                                    </CustomButton>
                                </FormFieldBox>
                            </Grid>
                        </form>
                    </FormProvider>
                    <Grid container spacing={1.5} alignItems="center">
                        <FormLabelBox />
                        <FormFieldBox>
                            <ErrorsList show={errorMessage !== ""}>{errorMessage}</ErrorsList>
                        </FormFieldBox>
                    </Grid>
                </Box>
            </BoxContent>
        </Box>
    )
}

export default GenerateClassroomLogs;